import actionTypes from './actionTypes';
import type { IRateEngineFormData } from './types';

const actions = {
  fetchRequest: () => ({ type: actionTypes.FETCH_REQUEST }),
  fetchSuccess: (data: IRateEngineFormData) => ({ type: actionTypes.FETCH_SUCCESS, payload: { data } }),
  fetchError: () => ({ type: actionTypes.FETCH_ERROR }),
};

export default actions;
